import React from "react";
 // Ensure CSS below is in this file or in your global CSS

function Trustedsection() {
  const productLists = [
    {
      title: "Smart Crop Solutions",
      description:
        "Chitracrop Science empowers farmers with precision farming, advanced nutrient management, and eco-friendly pest control for higher yield and sustainable growth.",
      colorClass: "card-1",
    },
    {
      title: "Balanced Crop Nutrition",
      description:
        "Ensure strong roots, healthy growth, and maximum productivity with Chitracrop Science’s scientifically formulated crop nutrition solutions.",
      colorClass: "card-2",
    },
    {
      title: "Eco-Friendly Pest Control",
      description:
        "Protect crops naturally with Chitracrop Science’s bio-based pest management products, safe for the environment and beneficial insects.",
      colorClass: "card-3",
    },
  ];

  return (
    <div className="container-fluid py-3 mt-5">
      <div className="row justify-content-center text-center g-4">
        {productLists.map((item, index) => (
          <div className="col-md-4" key={index}>
            <div className={`card-3d-animated p-4 shadow rounded h-100 ${item.colorClass}`}>
              <h2 className="fw-bold mb-3">{item.title}</h2>
              <p className={item.colorClass === "card-2" ? "text-dark" : "text-white"}>
                {item.description}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Trustedsection;
